import DataTable from "react-data-table-component";
import "./Table.css";

const Table = ({
  columns,
  data,
  defaultSortColumnId,
  defaultSortAsc = true,
  keyField,
  rowsPerPage = 25,
  key,
}) => {
  return (
    <div key={key}>
      <DataTable
        columns={columns}
        data={data}
        pagination={true}
        paginationPerPage={rowsPerPage}
        defaultSortFieldId={defaultSortColumnId}
        defaultSortAsc={defaultSortAsc}
        paginationRowsPerPageOptions={[1, 2, 3, 4].map((n) => n * rowsPerPage)}
        keyField={keyField ? keyField : "id"}
        responsive={true}
        customStyles={{
          headCells: {
            style: {
              fontSize: "16px",
              color: "#898989",
              justifyContent: "left",
              backgroundColor: "#f8fbff",
              borderTop: "1px solid #8A8F9320",
              fontFamily: "PlusJakartaSansMedium",
              textTransform: "capitalize",
              // wordSpacing: "2px",
              height: "68px",
            },
          },
          header: {
            style: {
              textOverflow: "initial",
              whiteSpace: "break-spaces",
              border: "none",
            },
          },
          cells: {
            style: {
              fontSize: "16px",
              justifyContent: "left",
              backgroundColor: "transparent",
              border: "none",
              fontFamily: "PlusJakartaSansRegular",
            },
          },
          rows: {
            style: {
              "&:nth-of-type(even)": {
                backgroundColor: "#FFFFFF",
                border: "none",
                height: "68px",
              },
              "&:nth-of-type(odd)": {
                backgroundColor: "#F7F7F7",
                border: "none",
                height: "68px",
              },
            },
          },
        }}
      />
    </div>
  );
};

export default Table;
